import React from "react";

import { Button, Modal, useManualModalState } from "@synthesis/shared-ui";

type ModalUpdateInformationProps = {
  trigger: React.ReactNode;
  title: string;
  setIsEdit: (value: boolean) => void;
};

export const ModalUpdateInformation = ({ trigger, title, setIsEdit }: ModalUpdateInformationProps) => {
  const { closeModal } = useManualModalState();

  return (
    <Modal.Root manual trigger={trigger as React.ReactElement}>
      <Modal.Content className="min-w-[550px]">
        <Modal.Title>Редактирование проекта</Modal.Title>
        <Modal.Description className="p-8">
          <h2 className="heading-h4">Проект &quot;{title}&quot; создан по интеграции</h2>
          <div className="paragraph-lg py-4">Данные получены по интеграции. Продолжить редактирование?</div>
          <div className="flex justify-between">
            <Button theme="primary" onClick={closeModal}>
              Нет
            </Button>
            <Button
              theme="secondary"
              onClick={() => {
                setIsEdit(true);
                closeModal();
              }}
            >
              Да
            </Button>
          </div>
        </Modal.Description>
      </Modal.Content>
    </Modal.Root>
  );
};
